export default __webpack_public_path__ + "static/media/payment_icon.4edc9dd4.svg";